import { render, staticRenderFns } from "./TabVisualPromotion.vue?vue&type=template&id=e7034704&scoped=true"
import script from "./TabVisualPromotion.vue?vue&type=script&lang=js"
export * from "./TabVisualPromotion.vue?vue&type=script&lang=js"
import style0 from "./TabVisualPromotion.vue?vue&type=style&index=0&id=e7034704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7034704",
  null
  
)

export default component.exports